/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name CompanyLogo                                                            **/
/**************************************************************************************************/
const CompanyLogo = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'CompanyLogo', mixins: [MixinResponsive],

	props:
	{
		home: { type: Boolean, default: false },
		logo: { type: String, default: 'LogoKreisSmall' }
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		GetLogo(): string
		{
			return require(`@/Resources/Images/${ this.logo }.png`)
		},

		IsUsedInHomeComponent(): { ['is-home']: boolean }
		{
			return { ['is-home']: this.home }
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		OnLogoClick() : void
		{
			if (this.home) this.$emit('onLogoClick')
		}
	}
})

/**************************************************************************************************/
/** @export Component @name CompanyLogo                                                          **/
/**************************************************************************************************/
export default CompanyLogo

/**************************************************************************************************/
/** @export Type @name CompanyLogoRef                                                            **/
/**************************************************************************************************/
export type CompanyLogoRef = InstanceType<typeof CompanyLogo>